export const RenderIcon = ({ file, ...rest }) => {
    const renderIcon = file => {
        switch (file.fileType) {
            case 'pdf':
                return <i className="far fa-file-pdf document-icon" {...rest} />;
            case 'jpg':
            case 'jpeg':
            case 'png':
                return <i className="far fa-file-image document-icon" {...rest} />;
            case 'doc':
            case 'docx':
                return <i className="far fa-file-word document-icon" {...rest} />;
            case 'xlsx':
                return <i className="far fa-file-excel document-icon" {...rest} />;
            default:
                return <i className="far fa-file document-icon" {...rest} />;
        }
    };

    return renderIcon(file);
};
